import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';

export const EPetitionDetailSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<>
			<ContentLayout>
				<LayoutGap>
					<GovSkeleton
						width={generateRandomNumber(40, 100) + '%'}
						height="26px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width={generateRandomNumber(40, 100) + '%'}
						height="20px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width={generateRandomNumber(40, 100) + '%'}
						height="20px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width={generateRandomNumber(40, 100) + '%'}
						height="20px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width={generateRandomNumber(40, 100) + '%'}
						height="20px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width={generateRandomNumber(40, 100) + '%'}
						height="20px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<div className="flex justify-between">
						<GovSkeleton
							width="140px"
							height="22px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
						<GovSkeleton
							width="22px"
							height="22px"
							shape="circle"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
					</div>
				</LayoutGap>
			</ContentLayout>
			<ContentLayout>
				<div className="flex flex-col [ md:flex-row md:justify-between md:items-center ]">
					<GovSkeleton
						width="300px"
						height="30px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="85px"
						height="40px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
			</ContentLayout>
		</>
	);
};
